import SalesPage from "@/page/Admin/Sales";

const adminRoute = {
  path: '/admin',
  children: [
    {
      path: 'sales',
      element: <SalesPage />,
    }
  ],
};

export default adminRoute;
